export default "skymp5-front/86e0f6bc29d947fc4a887cca3b2b90aa.png";